// Module
var code = "<p>&copy;Pennsylvania Higher Education Assistance Agency, 2018-2024. (NMLS# 1619466 <a href=\"http://www.nmlsconsumeraccess.org/\">NMLS Consumer Access</a>). All Rights Reserved.</p> <p>PHEAA conducts its student loan servicing operations commercially as American Education Services (AES).</p> ";
// Exports
export default code;